/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import GMap from './GMap';
import '../../App.css';
import { Checkbox, Col, Row } from 'antd';
import { Content } from 'antd/es/layout/layout';
import englan from '../../english.json';
import germanlan from '../../german.json';
import arabiclan from '../../arabic.json';
import frenchlan from '../../french.json';
import hindilan from '../../hindi.json';
import malayalamlan from '../../malayalam.json';

const Map = (props) => {
	const { onClick } = props;

	const [changePipe, setChangePipe] = useState(true);
	const [changeBorder, setChangeBorder] = useState(false);
	const [changeFiber, setChangeFiber] = useState(false);
	const [changeKMP, setChangeKMP] = useState(false);
	const [changeCH, setChangeCH] = useState(false);
	const [changeWB, setChangeWB] = useState(false);
	const [changeTP, setChangeTP] = useState(false);
	const [changeTLP, setChangeTLP] = useState(props.TLPData == 'TLPData' ? true : false);
	const [changeEvent, setChangeEvent] = useState(true);
	const [changeAlarm, setChangeAlarm] = useState(true);

	const [changeOptionalPipe, setOptionalChangePipe] = useState(false);

	const [changeinspectionLine, setInspectionLine] = useState(true);
	const [changeinspectionPoint, setInspectionPoint] = useState(false);

	const [changeWell, setChangeWell] = useState(true);

	// PLAY state for the Google map's animated trajectory replay. This must default to
	// false and only ever flip via the checkbox's onChange (onChangePInspectionLine) —
	// i.e. only when the user clicks it. This mirrors the OpenSeaMap/Leaflet view, where
	// PLAY only starts when the user toggles the "PLAY" layer in the LayersControl
	// (see the `add`/`remove` eventHandlers on the Polyline in RealtimeDetectionDetails.jsx).
	// There must be no effect here that auto-sets this to true just because detection
	// data becomes available — that was what caused PLAY to start on its own.
	const [changePlayinspectionLine, setPInspectionLine] = useState(false);

	// POINTS / POLY LINES — placed next to PLAY, apply specifically to detection
	// trajectories (props.datadetection). POINTS defaults ON (shows each detection's
	// individual point markers), POLY LINES defaults OFF (shows the line connecting
	// those points). Both are independent of PLAY and of the LINE/POINTS pair further
	// up that controls inspection-walker line/point display.
	const [changeDetectionPoints, setChangeDetectionPoints] = useState(true);
	const [changeDetectionPolyline, setChangeDetectionPolyline] = useState(false);

	// FIBRE DETECTION / SHIP-FIBRE LINK — mirrors SeaMap.jsx's "Fibre Detection" and
	// "Ship-Fibre Link" overlays. Fibre Detection plots each trajectory's
	// peakCoordinates point (defaults ON, same as SeaMap's `checked` Overlay).
	// Ship-Fibre Link draws a dashed line from every plotted ship point to that
	// peak coordinate (defaults OFF, same as SeaMap).
	const [changeFibreDetection, setChangeFibreDetection] = useState(true);
	const [changeShipFibreLink, setChangeShipFibreLink] = useState(false);

	// REFERENCE COORDINATES / COORDINATE-FIBRE LINK — mirrors SeaMap.jsx's
	// "Reference Coordinates" (defaults ON, `checked` Overlay) and
	// "Coordinate-Fibre Link" (defaults OFF) overlays. Independent of detection
	// data — these apply whenever coordinatesData is supplied by the parent.
	const [changeReferenceCoordinates, setChangeReferenceCoordinates] = useState(true);
	const [changeCoordinateFibreLink, setChangeCoordinateFibreLink] = useState(false);
	const [changeAISVessels, setChangeAISVessels] = useState(true);

	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid == 1 ? arabiclan : langid == 2 ? englan : langid == 3 ? frenchlan : langid == 4 ? germanlan : langid == 5 ? hindilan : langid == 6 ? malayalamlan : englan;

	const oneviewType = process.env.REACT_APP_ONEVIEW_TYPE ? process.env.REACT_APP_ONEVIEW_TYPE : 'pipeline';
	const oneviewtypeLabeluper = oneviewType &&  oneviewType.toLowerCase() == 'pipeline' ? langdata && langdata.PIPELINE : oneviewType.toLowerCase() == 'airport' ? langdata && langdata.AIRPORT : oneviewType.toLowerCase() == 'border' ? langdata && langdata.BORDER: oneviewType.toLowerCase() == 'railway' ? langdata && langdata.RAILWAY: oneviewType.toLowerCase() == 'subsea' ? langdata && langdata.SUBSEA  : 'PIPELINE';
	const hasDetection =
    Array.isArray(props.datadetection) &&
    props.datadetection.length > 0;

	useEffect(() => {
		setChangeEvent(props.filterDrawer === true ? false : true);
		setChangeAlarm(props.alarmfilterDrawer === true ? false : true);
	}, [props.filterDrawer, props.alarmfilterDrawer]);

	const onChangePipe = () => {
		changePipe === true ? setChangePipe(false) : setChangePipe(true);
	};

	const onChangeBorder = () => {
		changeBorder === true ? setChangeBorder(false) : setChangeBorder(true);
	};

	const onChangeFiber = () => {
		changeFiber === true ? setChangeFiber(false) : setChangeFiber(true);
	};

	const onChangeKMP = () => {
		changeKMP === true ? setChangeKMP(false) : setChangeKMP(true);
	};

	const onChangeCH = () => {
		changeCH === true ? setChangeCH(false) : setChangeCH(true);
	};

	const onchangeWB = () => {
		changeWB === true ? setChangeWB(false) : setChangeWB(true);
	};

	const onchangeTP = () => {
		changeTP === true ? setChangeTP(false) : setChangeTP(true);
	};

	const onchangeTLP = () => {
		changeTLP === true ? setChangeTLP(false) : setChangeTLP(true);
	};

	const onChangeEvnt = () => {
		changeEvent === true ? setChangeEvent(false) : setChangeEvent(true);
	};

	const onChangeAlarm = () => {
		changeAlarm === true ? setChangeAlarm(false) : setChangeAlarm(true);
	};

	const onChangeOptionalPipe = () => {
		changeOptionalPipe === true ? setOptionalChangePipe(false) : setOptionalChangePipe(true);
	};

	const onChangeInspectionLine = () => {
		changeinspectionLine === true ? setInspectionLine(false) : setInspectionLine(true);
	};

	const onChangeInspectionPoint = () => {
		changeinspectionPoint === true ? setInspectionPoint(false) : setInspectionPoint(true);
	};

	const onChangeWell = () => {
		changeWell === true ? setChangeWell(false) : setChangeWell(true);
	};

	// The ONLY place changePlayinspectionLine is toggled — fired by the user
	// clicking the PLAY checkbox, same as clicking the PLAY layer in SeaMap.
	const onChangePInspectionLine = () => {
		changePlayinspectionLine === true ? setPInspectionLine(false) : setPInspectionLine(true);
	};

	const onChangeDetectionPoints = () => {
		changeDetectionPoints === true ? setChangeDetectionPoints(false) : setChangeDetectionPoints(true);
	};

	const onChangeDetectionPolyline = () => {
		changeDetectionPolyline === true ? setChangeDetectionPolyline(false) : setChangeDetectionPolyline(true);
	};

	const onChangeFibreDetection = () => {
		changeFibreDetection === true ? setChangeFibreDetection(false) : setChangeFibreDetection(true);
	};

	const onChangeShipFibreLink = () => {
		changeShipFibreLink === true ? setChangeShipFibreLink(false) : setChangeShipFibreLink(true);
	};

	const onChangeReferenceCoordinates = () => {
		changeReferenceCoordinates === true ? setChangeReferenceCoordinates(false) : setChangeReferenceCoordinates(true);
	};

	const onChangeCoordinateFibreLink = () => {
		changeCoordinateFibreLink === true ? setChangeCoordinateFibreLink(false) : setChangeCoordinateFibreLink(true);
	};
	const onChangeAISVessels = () => {
		changeAISVessels === true ? setChangeAISVessels(false) : setChangeAISVessels(true);
	};

	return (
		<Content>
			{props.eventDetailsData || props.alarmDetailsData || props.TLPDetails ? null :
				<Row span={24} style={{ color: '#000000a6', margin: '10px' }}>
					<Col span={24}
						// className="map-filter-checkbox-row"
						style={{
							display: 'flex',
							flexWrap: 'wrap',
							alignItems: 'center',
							rowGap: '8px',
							// columnGap: '8px',
							// padding: '5px 4px',
						}}>
						{oneviewType != 'well' ?
							<>
								<Checkbox style={{ color: '#000000a6', alignContent: 'left' }} onChange={onChangeFiber}>{langdata && langdata.FIBER ? langdata.FIBER : 'FIBER'}</Checkbox>
								<Checkbox style={{ color: '#000000a6' }} defaultChecked onChange={onChangePipe}>{oneviewtypeLabeluper ? oneviewtypeLabeluper : 'PIPELINE'}</Checkbox>
								{dashboardtype !== 'tlp' && props.TLPData !== 'TLPData' ?
									<Checkbox style={{ color: '#000000a6' }} onChange={onChangeOptionalPipe}>{langdata && langdata.OPTIONALPATH ? langdata.OPTIONALPATH : 'OPTIONAL PATH'}</Checkbox>
									: null}
								<Checkbox style={{ color: '#000000a6' }} onChange={onChangeBorder}>{langdata && langdata.PIPELINEBORDER ? langdata.PIPELINEBORDER : 'PIPELINE BORDER'}</Checkbox>
								{props.eventData ?
									<Checkbox style={{ color: '#000000a6' }} checked={props.filterDrawer === true ? false : changeEvent} onChange={onChangeEvnt}>{langdata && langdata.EVENTS ? langdata.EVENTS : 'EVENTS'}</Checkbox>
									: null
								}
								{props.alarmData ?
									<Checkbox style={{ color: '#000000a6' }} checked={props.alarmfilterDrawer === true ? false : changeAlarm} onChange={onChangeAlarm}>{langdata && langdata.ALARMS ? langdata.ALARMS : 'ALARMS'}</Checkbox>
									: null
								}
								<Checkbox style={{ color: '#000000a6' }} onChange={onChangeKMP}>{langdata && langdata.KMP ? langdata.KMP : 'KMP'}</Checkbox>
								<Checkbox style={{ color: '#000000a6' }} onChange={onChangeCH}>{langdata && langdata.CH ? langdata.CH : 'CH'}</Checkbox>
								<Checkbox style={{ color: '#000000a6' }} onChange={onchangeWB}>{langdata && langdata.WB ? langdata.WB : 'WB'}</Checkbox>
								<Checkbox style={{ color: '#000000a6' }} onChange={onchangeTP}>{langdata && langdata.TURNINGPOINT ? langdata.TURNINGPOINT : 'TURNING POINT'}</Checkbox>
								<Checkbox style={{ color: '#000000a6' }} defaultChecked={props.TLPData == 'TLPData' ? true : false} onChange={onchangeTLP}>{langdata && langdata.TLP ? langdata.TLP : 'TLP'}</Checkbox>
								{ oneviewType === 'subsea' ? <Checkbox
									style={{ color: '#000000a6' }}
									checked={changeAISVessels}
									onChange={onChangeAISVessels}
								>
									{langdata && langdata.AISVessels ? langdata.AISVessels : 'AIS VESSELS'}
								</Checkbox> :null}
								{/* FIX: include props.datadetection here so this whole group (LINE / POINTS / PLAY)
								    renders even when inspectionData/patch_data/vulnerable_data are absent */}
								{props.inspectionData || props.patch_data || props.vulnerable_data || props.datadetection ?
									<>
										<Checkbox style={{ color: '#000000a6' }} defaultChecked onChange={onChangeInspectionLine}>{langdata && langdata.LINE ? langdata.LINE : 'LINE'}</Checkbox>
										<Checkbox style={{ color: '#000000a6' }} onChange={onChangeInspectionPoint}>{langdata && langdata.POINTS ? langdata.POINTS : 'POINTS'}</Checkbox>
										{props.inspectionData || props.datadetection ?
											<Checkbox
												style={{ color: '#000000a6' }}
												checked={changePlayinspectionLine}
												disabled={!hasDetection && !props.inspectionData}
												onChange={onChangePInspectionLine}
											>
												{langdata && langdata?.PLAY ? langdata.PLAY : 'PLAY'}
											</Checkbox> : null}
										{/* POINTS / POLY LINES for detection trajectories — placed right
										    next to PLAY, only relevant (and only rendered) when there is
										    detection data to toggle. Points is checked by default. */}
										{props.datadetection  && oneviewType === 'subsea' ?
											<>
												<Checkbox
													style={{ color: '#000000a6' }}
													checked={changeDetectionPoints}
													onChange={onChangeDetectionPoints}
												>
													{langdata && langdata.PlotPoints ? langdata.PlotPoints : 'PLOT POINTS'}
												</Checkbox>
												<Checkbox
													style={{ color: '#000000a6' }}
													checked={changeDetectionPolyline}
													onChange={onChangeDetectionPolyline}
												>
													{langdata && langdata.PlotLines ? langdata.PlotLines : 'PLOT LINES'}
												</Checkbox>
												{/* FIBRE DETECTION / SHIP-FIBRE LINK — same position/behavior as
												    SeaMap.jsx's equivalent Overlays: only shown when detection data
												    (and therefore possible peakCoordinates) exists. */}
												<Checkbox
													style={{ color: '#000000a6' }}
													checked={changeFibreDetection}
													onChange={onChangeFibreDetection}
												>
													{langdata && langdata.FibreDetection ? langdata.FibreDetection : 'FIBRE DETECTION'}
												</Checkbox>
												<Checkbox
													style={{ color: '#000000a6' }}
													checked={changeShipFibreLink}
													onChange={onChangeShipFibreLink}
												>
													{langdata && langdata.ShipFibreLink ? langdata.ShipFibreLink : 'SHIP-FIBRE LINK'}
												</Checkbox>
												<Checkbox
													style={{ color: '#000000a6' }}
													checked={changeReferenceCoordinates}
													onChange={onChangeReferenceCoordinates}
												>
													{langdata && langdata.ReferenceCoordinates ? langdata.ReferenceCoordinates : 'REFERENCE COORDINATES'}
												</Checkbox>
												<Checkbox
													style={{ color: '#000000a6' }}
													checked={changeCoordinateFibreLink}
													onChange={onChangeCoordinateFibreLink}
												>
													{langdata && langdata.CoordinateFibreLine ? langdata.CoordinateFibreLine : 'COORDINATE-FIBRE LINK'}
												</Checkbox>
											</> : null}
									</> :
									null}
								{/* REFERENCE COORDINATES / COORDINATE-FIBRE LINK — independent of
								    detection data; shown whenever the parent supplies coordinatesData
								    (mirrors SeaMap.jsx's always-available Reference Coordinates /
								    Coordinate-Fibre Link Overlays). */}
								{/* {props.coordinatesData ?
									<>
										<Checkbox
											style={{ color: '#000000a6' }}
											checked={changeReferenceCoordinates}
											onChange={onChangeReferenceCoordinates}
										>
											{langdata && langdata.ReferenceCoordinates ? langdata.ReferenceCoordinates : 'REFERENCE COORDINATES'}
										</Checkbox>
										<Checkbox
											style={{ color: '#000000a6' }}
											checked={changeCoordinateFibreLink}
											onChange={onChangeCoordinateFibreLink}
										>
											{langdata && langdata.CoordinateFibreLine ? langdata.CoordinateFibreLine : 'COORDINATE-FIBRE LINK'}
										</Checkbox>
										
									</> : null} */}
							</> :
							<>
								<Checkbox style={{ color: '#000000a6', alignContent: 'left' }} defaultChecked onChange={onChangeWell}>{langdata && langdata.WELL ? langdata.WELL : 'WELL'}</Checkbox>
								{props.eventData ?
									<Checkbox style={{ color: '#000000a6' }} checked={props.filterDrawer === true ? false : changeEvent} onChange={onChangeEvnt}>{langdata && langdata.EVENTS ? langdata.EVENTS : 'EVENTS'}</Checkbox>
									: null
								}
								{props.alarmData ?
									<Checkbox style={{ color: '#000000a6' }} checked={props.alarmfilterDrawer === true ? false : changeAlarm} onChange={onChangeAlarm}>{langdata && langdata.ALARMS ? langdata.ALARMS : 'ALARMS'}</Checkbox>
									: null
								}
							</>
						}
					</Col>
				</Row>
			}
			<GMap changePipe={changePipe} changeBorder={changeBorder} changeFiber={changeFiber} changeKMP={changeKMP}
				changeCH={changeCH} changeWB={changeWB} changeTP={changeTP} changeTLP={changeTLP} eventData={props.eventData} changeEvent={changeEvent} linewalkerData={props.linewalkerData}
				changeOptionalPipe={changeOptionalPipe} inspectionData={props.inspectionData} changeinspectionLine={changeinspectionLine} changeinspectionPoint={changeinspectionPoint}
				pigData={props.pigData} pidsData={props.pidsData && props.pidsData}
				regionId={props.regionId ? props.regionId : null} startCh={props.startCh || props.startCh === 0 ? props.startCh : null} endCh={props.endCh || props.endCh === 0 ? props.endCh : null}
				onClick={onClick}
				alarmData={props.alarmData} changeAlarm={changeAlarm} height={props.height} eventDetails={props.eventDetailsData} alarmDetails={props.alarmDetailsData}
				patch_data={props.patch_data} vulnerable_data={props.vulnerable_data} TLPDetails={props.TLPDetails} TLPData={props.TLPData} pidsRegionData={props.regionPids} pigPids={props.pigPids} changeWell={changeWell} changePlayinspectionLine={changePlayinspectionLine}
				changeDetectionPoints={changeDetectionPoints} changeDetectionPolyline={changeDetectionPolyline}
				changeFibreDetection={changeFibreDetection} changeShipFibreLink={changeShipFibreLink}
				changeReferenceCoordinates={changeReferenceCoordinates} changeCoordinateFibreLink={changeCoordinateFibreLink} changeAISVessels={changeAISVessels}
				coordinatesData={props.coordinatesData} onDeleteCoordinate={props.onDeleteCoordinate}
				center={props.center}
				datadetection={props.datadetection}
				showAISVessels={props.showAISVessels} />
			<br />
		</Content>
	);
};

export default Map;